import { create } from 'zustand'
import { GetCookie, RemoveCookie } from '../../utils/customHook/useCookies'

type AuthStoreType = {
  isLogin: boolean
  setLogin: () => void
  setLogout: () => void
}

const auth: boolean = GetCookie('token') ? true : false

export const useAuthStore = create<AuthStoreType>((set) => ({
  isLogin: auth,
  setLogin: () => set(() => ({ isLogin: true })),
  setLogout: () => {
    RemoveCookie('token')
    set(() => ({ isLogin: false }))
  },
}))
